import PropTypes from 'prop-types';
import React from 'react';
import Draggable from './draggable';

/**
 * @abstract
 */
export default class AbstractHover extends React.Component {
    static MOBILE_WIDTH = 600;
    static MIN_WIDTH_POPUP = 300;
    static TOP_POPUP_MOBILE = 120;
    static TOP_POPUP_DESKTOP = 240;

    /**
     * @abstract
     */
    renderContent() {
        throw new Error('AbstractHover/renderContent must be overridden');
    }

    renderTitle() {
        return this.props.zone.name;
    }

    className() {
        return 'zone-info';
    }

    draggableProps() {
        return {};
    }

    __renderContent() {
        return (
            <div className={`dialog ${this.className()}`}>
                <div className="dialog-header">{this.renderTitle()}</div>
                <div className="dialog-body">{this.renderContent()}</div>
            </div>
        );
    }

    render() {
        const content = this.__renderContent();
        let screenWidth = window.innerWidth;

        const position = {
            x: Number(this.props.mouseX) + AbstractHover.MIN_WIDTH_POPUP > screenWidth ? screenWidth - AbstractHover.MIN_WIDTH_POPUP : this.props.mouseX,
            y: screenWidth <= AbstractHover.MOBILE_WIDTH ? AbstractHover.TOP_POPUP_MOBILE : AbstractHover.TOP_POPUP_DESKTOP
        };

        // If mouse positions are given render draggable
        if (!isNaN(this.props.mouseX) && !isNaN(this.props.mouseY)) {
            return <Draggable position={position}>{content}</Draggable>;
        }

        return content;
    }
}

AbstractHover.propTypes = {
    zone: PropTypes.object.isRequired,
    mouseX: PropTypes.number,
    mouseY: PropTypes.number
};
